import React, { useEffect, useRef, useState } from 'react';
import './styles/test.css'
import TextAnimate from './components/TextAnimate';
import FirstPattern from './components/FirstPattern';
import SecondPattern from './components/SecondPattern';
import ProjectsPattern from './components/ProjectsPattern';
import ProjectSlide from './components/ProjectSlide';
import StyledButton from './components/StyledButton'
import ScrollArrows from './components/ScrollArrows';
import pytorch from './images/pytorch.png'
import opencv from './images/opencv.png'
import sckit from './images/scikit.png'
import keras from './images/keras.png'
import html from './images/html.png'
import css from './images/css.png'
import js from './images/js.png'
import react from './images/react.png'
import python from './images/python.png'
import node from './images/node.png'
import flask from './images/flask.png'
import mangodb from './images/mangodb.png'

const Test = ({currentStage})=>{
   
    
    /*
    useEffect(()=>{
        setLength(fpath.current.getTotalLength())
        window.addEventListener('scroll',()=>handleScroll())
        
    
    return ()=>{
        window.removeEventListener('scroll',()=>handleScroll())
        
    }
})

   const handleScroll = ()=>{
    setVisiblity(true)
    var scrollp =  (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
    var currentScroll = scrollp * 10
    
    
    let currentDraw = length * (maxReached.current/10) *1.3

        if(prevScroll.current < currentScroll){
            if(currentScroll >= maxReached.current){
             maxReached.current = currentScroll
            }

            }
                
            prevScroll.current = currentScroll
           
            console.log("maxReached : ",maxReached.current)
            setDashOffset(length - currentDraw)
            console.log(length - currentDraw)
        }
          */
    
    
   
return(
    <>
<div className='svg-container'>
<div className='svgs'>
    <div className={currentStage === 2 ? 'fadeOut section' : 'section'}>
    
        <div  className='inside-section'>
        
    <FirstPattern trigger={currentStage === 1 ? true:false }/>
    <div className='skills-text'>

<TextAnimate direction="toTop">
<p   className='title'>Deep Learning / Machine Learning</p>
</TextAnimate>
<TextAnimate direction="toTop">
    <div  className='description'>
    <p>Building and deploying DL/ML models with a variety 
of tools and frameworks including : </p>
</div>
</TextAnimate>
</div>
<TextAnimate direction="toRight">
<div className='logos'>
    <div className='tool'>
        <img src={pytorch} style={{height:'70px',width:'70px'}}></img>
        <p>PyTorch</p>
    </div>
    
    <div className='tool'>
        <img src={opencv} style={{height:'70px',width:'70px'}}></img>
        <p>OpenCV</p>
    </div>
    <div className='tool'>
        <img src={keras} style={{height:'70px',width:'70px'}}></img>
        <p>Keras</p>
    </div>
    <div  className='tool'>
        <img src={sckit} style={{height:'70px',width:'120px'}}></img>
        <p>Sikit-Learn</p>
    </div>
    
</div>

</TextAnimate>
</div>
</div>

</div>








<div className={currentStage === 3 ? 'fadeOut section' : 'section'}>
<div  className='inside-section'>

<SecondPattern trigger={currentStage === 2 ? true:false }/>



<TextAnimate direction="toTop">
    
<p  className='title'>Full stack Development</p>
</TextAnimate>
<TextAnimate direction="toTop">
    <div  className='description'>
    <p>I create successful responsive websites that are fast, easy to use, and built with best practices. : </p>
</div>
</TextAnimate>
<TextAnimate direction="toRight">
<div className='logos'>
    <div className='tool'>
        <img src={html} style={{height:'80px',width:'80px'}}></img>
        <p>HTML</p>
    </div>
    
    <div className='tool'>
        <img src={css} style={{height:'80px',width:'80px'}}></img>
        <p>CSS</p>
    </div>
    <div className='tool'>
        <img src={js} style={{height:'80px',width:'80px'}}></img>
        <p>JavaScript</p>
    </div>
    <div className='tool'>
        <img src={react} style={{height:'80px',width:'80px'}}></img>
        <p>ReactJS</p>
    </div>
    <div className='tool'>
        <img src={node} style={{height:'80px',width:'130px'}}></img>
        <p>NodeJS</p>
    </div>
    <div className='tool'>
        <img src={python} style={{height:'80px',width:'80px'}}></img>
        <p>Python</p>
    </div>
    <div className='tool'>
        <img src={flask} style={{height:'80px',width:'80px'}}></img>
        <p>Flask</p>
    </div>
    <div  className='tool'>
        <img src={mangodb} style={{height:'80px',width:'80px'}}></img>
        <p>MangoDB</p>
    </div>
    
</div>

</TextAnimate>


</div>
</div>
<div className={currentStage === 4 ? 'fadeOut section' : 'section'}>
<div  className='inside-section'>
<ProjectsPattern trigger={currentStage === 3 ? true:false }/>
<ScrollArrows currentStage={currentStage}/>
</div>
</div>
<div className='section'>

<div  className='inside-section'>
<div className='section'>

<ProjectSlide current={currentStage} trigger={currentStage === 4 ? true:false }/>
<a target="_blank" href='https://github.com/ChibaniMohamed' className='button'>
<StyledButton type="standard" content="See More"/>
</a>
</div>
</div>




</div>
{/*
<div className='section'>
<SecondProjectSlide trigger={currentStage === 5 ? true:false }/>
</div>
*/}

</div>

</>


)
}
export default Test;